import React, { Dispatch, SetStateAction } from 'react';
import authClasses from './../Auth.module.scss';
import { Auth } from '../index';
import { BoxNotification } from '../../../components/containers/BoxNotification';
import { Button } from '../../../components/actions/Button';
import { ButtonColorsEnum } from '../../../constants/button-colors';
import { IconsEnum } from '../../../constants/icons';
import { JoinOrganizationType } from '../Invite/Invite.controller';

export type JoinOrganizationViewProps = {
  //
  email: string;
  error?: string | JSX.Element;
  info?: string | JSX.Element;
  joinAction: JoinOrganizationType;
  joinWithDifferentEmail: VoidFunction;
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
  token: string;
};

export const JoinOrganizationView = (props: JoinOrganizationViewProps): JSX.Element => {
  const errorMessage =
    props.error && !props.loading ? (
      <div className={'margin-bottom-small-32'}>
        <BoxNotification type={'error'}>{props.error}</BoxNotification>
      </div>
    ) : null;
  const infoMessage = props.info ? (
    <div className={'margin-bottom-small-32'}>
      <BoxNotification type={'info'}>{props.info}</BoxNotification>
    </div>
  ) : null;
  return (
    <Auth>
      <div className={authClasses.Title}>
        <div className={'margin-bottom-small-40'}>
          <h2>Join the Organization</h2>
        </div>
        {errorMessage}
        {infoMessage}
        <div className={'margin-bottom-small-32 uppercase'}>
          <h6 className={'light-grey-text'}>Join with</h6>
        </div>
        <div className={'margin-bottom-small-24'}>
          <Button
            loading={props.loading}
            action={() => {
              props.setLoading(true);
              props.joinAction(props.token);
            }}
            type={'button'}
            variant={'solid'}
            size={'large'}
            color={ButtonColorsEnum.secondary}
            expanded
            justifiedIcon
            icon={{ side: 'right', value: IconsEnum.arrowRight }}>
            {props.email}
          </Button>
        </div>
        <Button
          loading={props.loading}
          action={() => props.joinWithDifferentEmail()}
          type={'button'}
          variant={'hollow'}
          size={'large'}
          color={ButtonColorsEnum.secondary}
          expanded
          justifiedIcon
          icon={{ side: 'right', value: IconsEnum.arrowRight }}>
          A different email
        </Button>
      </div>
    </Auth>
  );
};
